import { Injectable } from '@angular/core';
import { CaseCategory } from '../../models/case-category';
import { HttpService } from '../../services/http/http.service';

@Injectable()
export class CaseCategoryService extends HttpService<CaseCategory> {
  route = 'casecategory';
}
